<template>
  <div class="text-white">
    <h1 class="text-white">
      <i class="far fa-style lh-inherit"></i> {{ 'Choose a Style' | trans }}
    </h1>
    <p class="text-white">
      {{ 'Ever dreamed of capturing the essence of a Renaissance masterpiece ? Or perhaps you want to unleash the vividness of abstract expressionism ?' | trans }}
    </p>
    <p class="text-white">
      {{ 'Select from a variety of renowned art styles, ranging from classical to contemporary, and watch as our AI - powered engine transforms your ideas into stunning visual masterpieces.' | trans }}
    </p>
  </div>
</template>
<script>

export default {
  name: "StyleDescription",
  props: {},
  components: {},
  mixins: [],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
h1 {
  margin: 0 0 10px 0;
  font-size: 28px;
}

p {
  font-size: 14px;
}

</style>
